import { useState, useEffect, useCallback } from "react";
import SweetAlert from "@components/Feedback/SweetAlert/Index";
import { GetAllItensDoProcesso } from "@services/ItensProcesso/Index";
import { useFetchPaginatedData } from "@hooks/api/useFetchPaginatedData";

export const useFetchItensByProcesso = () => {
  const [itensProcessoLoading, setLoading] = useState(false);
  const [itensProcessoOptions, setOptions] = useState([]);
  const [totalItens, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const {
    data: allItensProcesso,
    loading: paginatedItensLoading,
    fetchAllData: fetchAllItensProcesso
  } = useFetchPaginatedData(GetAllItensDoProcesso);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      fetchAllItensProcesso();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  const fetchItensByProcesso = useCallback(async (idProcesso, etapaProcesso, page = 1, perPage = 10) => {
    if (!idProcesso || allItensProcesso.length === 0) return null;

    setLoading(true);
    try {
      const itensFiltrados = allItensProcesso.filter(
        (item) => item.idProcesso === idProcesso && item.etapaProcesso === etapaProcesso
      );

      const options = itensFiltrados.map((item) => ({
        id: item.id,
        value: item.id,
        label: item.nomeProcesso,
        nomeItem: item.nomeItem,
        codigo: item.codigo,
      })).sort((a, b) => a.label.localeCompare(b.label));

      setOptions(options);
      setTotal(itensFiltrados.length);
      setCurrentPage(page);
      setRowsPerPage(perPage);

      return itensFiltrados.map((item) => ({
        id: item.id,
        nomeItem: item.nomeItem,
      }));
    } catch (error) {
      console.error("Erro ao buscar itens do processo:", error);
      SweetAlert.error("Erro ao buscar itens do processo", String(error));
      setOptions([]);
      setTotal(0);
      return null;
    } finally {
      setLoading(false);
    }
  }, [allItensProcesso]);

  return {
    fetchItensByProcesso,
    itensProcessoOptions,
    setItensProcessoOptions: setOptions,
    itensProcessoLoading: itensProcessoLoading || paginatedItensLoading,
    totalItens,
    currentPage,
    rowsPerPage,
    setCurrentPage,
    setRowsPerPage,
  };
};
